import { ReactNode } from 'react';

import { useCharityStyle } from '../../Shared/useCharityStyle';
import { SharedProps } from '../types';
import Container from '../UI/Container';
import Layout from '../UI/Layout';
import { CharitySettingsLayout } from './CharitySettingsLayout';
import EditMailSettingsForm, { EditMailSettingsFormProps } from './EditMailSettingsForm';

export interface MailSettingsPageProps extends SharedProps {
  charity: EditMailSettingsFormProps['charity'];
}

export default function MailSettingsPage({
  charity,
  auth: { user },
}: MailSettingsPageProps) {
  useCharityStyle(charity);

  return (
    <Container size="md" className="space-y-6">
      <EditMailSettingsForm
        charity={charity}
        user={user}
      />
    </Container>
  );
}

MailSettingsPage.layout = (page: ReactNode) => <Layout><CharitySettingsLayout>{page}</CharitySettingsLayout></Layout>;

